/* eslint-disable */
import React, { useEffect } from "react";

const TagInput = ({
    label,
    name,
    placeholder,
    register,
    errors,
    setValue,
    tags,
    setTags,
}) => {

    const addTag = (tag) => {
        if (tag && !tags.includes(tag)) {
            setTags([...tags, tag]);
        }
    };
    const removeTag = (tagToRemove) => {
        setTags(tags.filter((tag) => tag !== tagToRemove));
    };
    const handleInputKeyPress = (e) => {
        if (e?.key === "Enter" ||
            e?.key === "," ||
            e?.key === " " ||
            e?.nativeEvent?.data === " " ||
            e?.nativeEvent?.data === ",") {
            e.preventDefault();
            const tag = e.target.value.trim();
            if (tag) {
                addTag(tag);
            }
            e.target.value = "";
        }
    };
    useEffect(() => {
        setValue(name, tags);
    }, [name, tags, setValue]);

    return (
        <div className="tag-input">
            <label className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1' htmlFor="justForInput">{label} <sup className='text-pink-200'>*</sup></label>
            <div className="flex items-center flex-wrap gap-4">
                {tags.map((tag) => (
                    <div key={tag} className="bg-yellow-900 cursor-default border-yellow-50 border text-yellow-50 max-w-fit rounded-xl flex justify-center items-center gap-x-2 py-[.1rem] px-2 my-2">
                        {tag}
                        <span
                            onClick={() => removeTag(tag)}
                            className="text-sm font-medium cursor-pointer"
                        >x</span>
                    </div>
                ))}
            </div>
            <input
                className="hidden"
                name={name}
                {...register(name, { required: true })}
            />
            <input
                type="text"
                className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                name="justForInput"
                id="justForInput"
                placeholder={placeholder}
                onKeyDown={handleInputKeyPress}
                onChange={handleInputKeyPress}
            />
            {errors[name] && <span className='text-pink-200 text-sm'>at least one tag are required</span>}
        </div>
    );
};

export default TagInput;